import React, { useContext } from 'react'
import GuaranteePrice from "app/React/Components/Footer/GuaranteePrice";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function GuaranteePriceField(props) {
  const {
    currentVariant,
    lang,
    order,
    strings
  } = useContext(ConfiguratorContext)

  const miscStrings = strings.misc ?? {}
  const priceStrings = strings.price?.formats ?? {}

  const useDisplayGuaranteePrice = () => Boolean(Number(currentVariant.steps?.[5]?.show_guarantee_price ?? '0'))

  if (!useDisplayGuaranteePrice() || typeof order.guarantee_price !== 'number' || typeof order.guarantee_price_car !== 'string') {
    return null
  }

  return (
    <>
      <div className='config-overview__title'>
        <div>{miscStrings.guarantee_price_title}</div>
        <div>
          <GuaranteePrice
            guarantee_price={order.guarantee_price}
            cash_string={priceStrings.cash}
          />
        </div>
      </div>

      {typeof order?.guarantee_price_outstanding_debt === 'string' && order?.guarantee_price_outstanding_debt.length > 0 && (
        <div className="config-overview__price">
          <div>{miscStrings.outstanding_debt}</div>
          <div>
            <>-{new Intl.NumberFormat(lang).format(order?.guarantee_price_outstanding_debt)}</>
            {' '}
            {priceStrings.cash}
          </div>
        </div>
      )}

      <div className="config-overview__price">
        <div>{miscStrings.model}</div>
        <div>{order.guarantee_price_car}</div>
      </div>
    </>
  )
}
